// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refund-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: 50px 20px;
}

.refund-container {
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.refund-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
  line-height: 1.4;
  padding-top: 5vh;
}

.effective-date,
.intro-text {
  font-size: 16px;
  color: #475569;
  margin-bottom: 20px;
  line-height: 1.7;
}

.policy-section {
  margin-bottom: 30px;
}

.policy-section h2 {
  font-size: 24px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 15px;
}

.policy-section p,
.policy-section li {
  font-size: 16px;
  color: #475569;
  line-height: 1.8;
}

.policy-section ul {
  padding-left: 20px;
  margin: 0;
}

.policy-section li {
  margin-bottom: 10px;
}

.support-section a {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
}

.support-section a:hover {
  text-decoration: underline;
}

@media (max-width: 767.98px) {
  .refund-container {
    padding: 25px;
  }

  .refund-title {
    font-size: 26px;
  }

  .policy-section h2 {
    font-size: 20px;
  }

  .policy-section p,
  .policy-section li,
  .effective-date,
  .intro-text {
    font-size: 15px!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/RefundCancellationPolicy.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,yBAAyB;EAC3B;AACF","sourcesContent":[".refund-page {\n  background: #f8fafc;\n  min-height: 100vh;\n  padding: 50px 20px;\n}\n\n.refund-container {\n  max-width: 900px;\n  margin: 0 auto;\n  background: #ffffff;\n  padding: 40px;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.refund-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 20px;\n  line-height: 1.4;\n  padding-top: 5vh;\n}\n\n.effective-date,\n.intro-text {\n  font-size: 16px;\n  color: #475569;\n  margin-bottom: 20px;\n  line-height: 1.7;\n}\n\n.policy-section {\n  margin-bottom: 30px;\n}\n\n.policy-section h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 15px;\n}\n\n.policy-section p,\n.policy-section li {\n  font-size: 16px;\n  color: #475569;\n  line-height: 1.8;\n}\n\n.policy-section ul {\n  padding-left: 20px;\n  margin: 0;\n}\n\n.policy-section li {\n  margin-bottom: 10px;\n}\n\n.support-section a {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.support-section a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 767.98px) {\n  .refund-container {\n    padding: 25px;\n  }\n\n  .refund-title {\n    font-size: 26px;\n  }\n\n  .policy-section h2 {\n    font-size: 20px;\n  }\n\n  .policy-section p,\n  .policy-section li,\n  .effective-date,\n  .intro-text {\n    font-size: 15px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
